import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';

import { LoyaltyProgramCategory } from '../../models';

import { CategoryChangeEvent } from './types';

@Component({
  selector: 'lp-category-cell',
  templateUrl: './category-cell.component.html',
  styleUrls: ['./category-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryCellComponent {
  /** TODO: не используется */
  @Input() count = 0;

  @Input() selected = false;
  @Input() category?: LoyaltyProgramCategory;
  @Input() readonly = false;
  @Input() withBackground = false;
  @Output() cellClick = new EventEmitter<CategoryChangeEvent>();

  click() {
    if (this.category) {
      this.cellClick.emit({ ...this.category, select: !this.selected });
    }
  }
}
